<script>

import CustomersApi from '../../../../api/CustomersApi';
import Segment from '../../../../Segment';
import DDLogs from '../../../../DDLogs';

export default {
  name: 'Complete2FALoginScreen',
  async created() {
    try {
      await CustomersApi.complete2faLogin();
      window.location.href = `/${this.$route.query.redirectTo || 'sr'}`;
    } catch (e) {
      Segment.trackUserGot('Bad2faLoginError');
      DDLogs.error('Error happened during 2fa login completion', e);
    }
  },
};
</script>
